// ⛔️Generated file. Manual changes will be lost ⛔️

export class HttpConsts {
    public static readonly CrsfToken: string = 'CRSF_TOKEN';
    public static readonly CrsfTokenHeaderName: string = 'Crsf-Token';
    public static readonly JwtToken: string = 'JWT_TOKEN';
    public static readonly WorkflowIdHeaderName: string = 'Workflow-Id';
}
